import { useSelector } from 'react-redux';

import { breederProfileBreederTestimonialIndexResourceDefinition } from 'dpl/shared/breeder/utils/queryDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

export default function usePaginatedTestimonials(perPage, pageNumber) {
  const breederProfileId = useSelector(({ server }) => server.breederProfileId);
  const { isLoading, value } = useResourceQuery(
    breederProfileBreederTestimonialIndexResourceDefinition(breederProfileId, {
      pageNumber,
      perPage
    })
  );

  return {
    isLoading,
    testimonials: value?.data,
    meta: value?.meta
  };
}
